import router from '../router'
import store from '@/store'
import Cookies from 'js-cookie'
import { Message } from 'element-ui'
import conditionApi from '@/api/conditions'
import { getFuncOnlyExecuteOnlyOnce } from '../utils/etc'

const checkIfContainReinstallData = (to) => {
  return to.query && to.query.view === 'reinstall'
}
const getRouterParamToLoginPage = (isReinstallProcess, to) => {
  return {
    name: 'Login',
    query: isReinstallProcess ? to.query : undefined
  }
}
const initSelectedData = getFuncOnlyExecuteOnlyOnce((data) => {
  store.dispatch('speedCalculation2/setOptions', data)
})

// 在所有vue-route動作前啟用
router.beforeEach((to, from, next) => {
  const token = Cookies.get('qp_access_token')
  const sessionUserInfo = JSON.parse(window.sessionStorage.getItem('qpUserInfo'))
  const isLogin = token && sessionUserInfo
  // 判斷權限： vue-route 中 meta: { requiresAuth: true } 的代表需要登入
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (isLogin) {
      conditionApi.getSpeedOptions().then(({ data }) => {
        initSelectedData(data)
        store.dispatch('root/setUserInfo', sessionUserInfo)
        next()
      })
    } else {
      const isReinstallProcess = checkIfContainReinstallData(to)
      const routerParam = getRouterParamToLoginPage(isReinstallProcess, to)
      if (!isReinstallProcess) {
        // 未登入的狀況下進入根目錄，與其他頁面的對應提示文字
        const message = from.path === '/' ? '請先登入後再進行操作' : '登入時效已過期，請重新登入'
        Message.warning(message)
      }
      // 判斷未登入的則帶到登入頁
      next(routerParam)
    }
  } else {
    // 如不需權限的頁面，檢查是否有登入了
    if (isLogin && to.name === 'Login') {
      next({ name: 'Index' })
    } else {
      next()
    }
  }
})
